
import { AfterViewChecked, Component, ElementRef, inject } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { TableViewComponent } from "../table-view.component";
import { TableListViewGroupComponent } from "./table-list-view-group/table-list-view-group.component";

@Component({
  selector: "app-table-list-view",
  imports: [MatExpansionModule, TableListViewGroupComponent],
  templateUrl: "./table-list-view.component.html",
  styleUrl: "./table-list-view.component.less",
})
export class TableListViewComponent extends TableViewComponent implements AfterViewChecked {
  public minHeight: number | null;

  private ref: ElementRef<HTMLElement>;

  public constructor() {
    super();
    this.minHeight = null;
    this.ref = inject(ElementRef);
  }

  public ngAfterViewChecked(): void {
    this.setColumnWidths();
    this.setHeight();
  }

  public setColumnWidths(): void {
    const element = this.ref?.nativeElement;
    if (element) {
      const headers = element.querySelectorAll(".header-row");
      const widths: (number | null)[] = [];
      let rowIndex = 0;
      for (const header of headers) {
        const columns = header.querySelectorAll<HTMLTableCellElement>("th.field-header");
        let colIndex = 0;
        for (const column of columns) {
          const h = this.headers.at(colIndex);
          if (!h) continue;

          if (rowIndex === 0) {
            let width: number | null = null;
            switch (h.pfx) {
              case "idp":
                width = 32;
                break;
            }
            widths.push(width);
            if (width !== null) h.options.width = `${width}px`;
          }
          const newWidth = widths.at(colIndex);
          if (newWidth !== null) column.style.width = `calc(${newWidth}px)`;
          colIndex++;
        }
        rowIndex++;
      }
    }
  }

  public setHeight(): void {
    const element = this.ref?.nativeElement;
    if (element) {
      const rows = element.querySelectorAll<HTMLTableRowElement>("tr.data-row");
      if (rows.length === this.options.pageSize) {
        if (this.minHeight === null || this.minHeight < element.clientHeight) this.minHeight = element.clientHeight;
        element.style.minHeight = `${this.minHeight}px`;
      }
      if (rows.length === 0) {
        element.style.minHeight = "";
      }
    }
  }

  public override sortColumns(): void {
    if (this.options.layout) {
      const { list_columns } = this.options.layout;
      this.headers.sort((a, b) => list_columns.indexOf(a.name) - list_columns.indexOf(b.name));
      for (const row of this.getAllRows()) {
        row.fields.sort((a, b) => list_columns.indexOf(a.name) - list_columns.indexOf(b.name));
      }
    }
  }
}
